module.exports = __webpack_public_path__ + "img/pay_transfer.26c6d4e3.png";